export default {
  namespaced: true,

  state: {
    stepper_id: 1,
    business_stepper_id: 1,
    vehicle_stepper_id: 1,
    business_entity_type: "",
    lead_creation: "",
    existing_lead_creation_id: "",
    business_loan_overlay: false,
    business_loan_lead_creation: "",
    lap_loan_lead_creation: "",
    is_applicant_kyc_completed: false,
    is_existing_customer: false,
    product_type: "",
    basic_information: {
      basic_details: {
        borrower_name: "",
        guardian_name: "",
        mother_name:"",
        mobile_no: "",
        email_id: "",
        gender: "",
        dob: "",
        marital_status: "",
        highest_degree: "",
        institute: "",
 
      },
      current_add: {
        resident_type: "Own",
        address_line_one: "",
        address_line_two: "",
        pincode: "",
        city: "",
        state: "",
        is_permanent_address: false,
        same_as_aadhar: false,
        no_of_years_in_current_city:"",
        no_of_years_in_current_address:"",
      },
      permanent_add: {
        is_permanent_address: true,
        resident_type: "Rented",
        address_line_one: "",
        address_line_two: "",
        pincode: "",
        city: "",
        state: "",
      },
      reference_info: [
        {
          name: "",
          relationship_type: "",
          contact_number: "",
          to_be_call: true,
          is_friend: false,
        },
        {
          name: "",
          contact_number: "",
          relationship_type: "",
          to_be_call: true,
          is_friend: false,
        },
        {
          name: "",
          contact_number: "",
          relationship_type: "",
          to_be_call: true,
          is_friend: true,
        },
        {
          name: "",
          contact_number: "",
          relationship_type: "",
          to_be_call: true,
          is_friend: true,
        },
      ],
    },
    employment_information: {
      employment_type: "Self Employed",
      salary_type: "Direct Account Transfer",
      company_name: "",
      complete_company_address: "",
      designation: "",
      work_experience_in_year: null,
      work_experience_in_months: null,
      monthly_income: null,
      company_email_id: "",
      
      //Employed
      current_company_exprience:"",
     //Business
      business_type:"",
      business_ownership:"",
      turnover:null,
      business_vintage:null,
    },

    property_information:{
    total_properties:null,
    property_address:"",
    
    property_classification:"",
    property_usage:"",
    property_type:"",
    pincode:null,

      property_owners:[],
      property_registration_date:null,
      market_value:null,
      khasara_no:"",
      ploat_area:null,
      buildup_area:null,
      super_buildup_area:null,
      carpet_area:null,
      diversion:false,

      register_date:"",
      register_date_menu:false,
      diversion_date_menu:false,
      diversion_date:"",
    },

    bank_information: {
      bank_name: "",
      bank_branch_name:"",
      account_number: "",
      IFSC_code: "",
      account_holder_name: "",
    },

    identity_info: {
      aadhar_card_front_file: "",
      aadhar_number: "",
      pan_number: "",
    },
    uploaded_document: [
      {
        document_type: "",
        uploaded_file: "",
        uploaded_url: "",
        document_password: "",
      },
    ],

    has_bl_primary_bank_account: false,
    has_pl_primary_bank_account: false,
    has_bl_documents_uploaded: false,
    is_bl_personal_details_valid: false,
    is_bl_business_details_valid: false,
    dealer_lead_id: null,
    dealer_company: "",
    los_agent_check_form: {
      full_name: "",
      dob: "",
      pan: "",
    },
    business_basic_details: {},
    are_business_documents_uploaded: false,

    is_additional_details_valid: true,
    is_address_details_valid: true,
    is_address_proof_valid: false,
    is_kyc_valid: false,
    is_bank_details_valid: false,

    // Map of {form_field: source_label} for fields auto-filled from the
    // borrower's already-captured reports (AA / Credit Report / KYC docs).
    prefill_sources: {},
  },

  getters: {
    getStepperId: (state) => state.stepper_id,
    getBusinessStepperId: (state) => state.business_stepper_id,
    // getPropertyStepperId: (state) => state.property_stepper_id,
    getVehicleStepperId: (state) => state.vehicle_stepper_id,
    getBusinessEntityType: (state) => state.business_entity_type,
    getLeadCreation: (state) => state.lead_creation,
    getBusinessLeadCreation: (state) => state.business_loan_lead_creation,
    getLAPLeadCreation: (state) => state.lap_loan_lead_creation,
    // getBusinessNewLeadCreation: (state) =>
    //   state.business_loan_new_lead_creation,
    getLeadDetails: (state) => state,
    getBasicInfo: (state) => state.basic_information,
    getEmploymentInfo: (state) => state.employment_information,
    getPropertyInfo:(state)=>state.property_information,
    getBankDetails: (state) => state.bank_information,
    getIdentity: (state) => state.identity_info,
    getUploadedDocument: (state) => state.uploaded_document,
    getExistingLeadCreationId: (state) => state.existing_lead_creation_id,
    getIsExistingCustomer: (state) => state.is_existing_customer,
    getIsAppplicantKycCompleted: (state) => state.is_applicant_kyc_completed,
    getBusinessLoanOverlay: (state) => state.business_loan_overlay,
    getHasBlPrimaryBankAccount: (state) => state.has_bl_primary_bank_account,
    getHasPlPrimaryBankAccount: (state) => state.has_pl_primary_bank_account,
    getHasBlDocumentsUploaded: (state) => state.has_bl_documents_uploaded,
    getIsBlPersonalDetailsValid: (state) => state.is_bl_personal_details_valid,
    getIsBlBusinessDetailsVaild: (state) => state.is_bl_business_details_valid,
    getDealerLeadId: (state) => state.dealer_lead_id,
    getDealerCompany: (state) => state.dealer_company,
    getLosAgentCheckForm: (state) => state.los_agent_check_form,
    getBusinessBasicDetails: (state) => state.business_basic_details,
    getAreBusinessDocumentUploaded: (state) => state.are_business_documents_uploaded,
    getProductType: (state) => state.product_type,
    getPrefillSources: (state) => state.prefill_sources,
    getPlFormsStatus: (state) => {
      return {
        is_additional_details_valid : state.is_additional_details_valid,
        is_address_details_valid : state.is_address_details_valid,
        is_address_proof_valid : state.is_address_proof_valid,
        is_kyc_valid : state.is_kyc_valid,
        is_bank_details_valid : state.is_bank_details_valid
      }
    }
  },

  mutations: {
    SET_STEPPER_ID(state, value) {
      state.stepper_id = value;
    },
    SET_BUSINESS_STEPPER_ID(state, value) {
      state.business_stepper_id = value;
    },
    // SET_PROPERTY_STEPPER_ID(state, value) {
    //   state.property_stepper_id = value;
    // },
    SET_VEHICLE_STEPPER_ID(state, value) {
      state.vehicle_stepper_id = value;
    },
    SET_BUSINESS_ENTITY_TYPE(state, value) {
      state.business_entity_type = value;
    },
    SET_LEAD_CREATION(state, value) {
      state.lead_creation = value;
    },
    SET_BUSINESS_LEAD_CREATION(state, value) {
      state.business_loan_lead_creation = value;
    },
    SET_LAP_LEAD_CREATION(state, value) {
      state.lap_loan_lead_creation = value;
    },
    SET_HAS_BL_PRIMARY_BANK_ACCOUNT(state, value) {
      state.has_bl_primary_bank_account = value;
    },
    SET_HAS_PL_PRIMARY_BANK_ACCOUNT(state, value) {
      state.has_pl_primary_bank_account = value;
    },
    SET_HAS_BL_DOCUMENTS_UPLOADED(state, value) {
      state.has_bl_documents_uploaded = value;
    },
    SET_IS_BL_PERSONAL_DETAILS_VALID(state, value) {
      state.is_bl_personal_details_valid = value;
    },
    SET_IS_BL_BUSINESS_DETAILS_VALID(state, value) {
      state.is_bl_business_details_valid = value;
    },
    SET_LEAD_DETAILS: (state, obj) => {
      state.basic_information.customer_id = obj.customer_id;
      state.basic_information.borrower_name = obj.borrower_name;
      state.basic_information.guardian_name = obj.guardian_name;
      state.basic_information.mother_name = obj.mother_name;
      state.basic_information.gender = obj.gender;
      state.basic_information.dob = obj.dob;
      state.basic_information.marital_status = obj.marital_status;
      state.basic_information.mobile_no = obj.mobile_no;
      state.basic_information.email_id = obj.email_id;
      state.basic_information.highest_degree = obj.highest_degree;
      state.basic_information.institute = obj.institute;
    },
    SET_BASIC_INFO(state, obj) {
      state.basic_information.customer_id = obj.customer_id;
      state.basic_information.borrower_name = obj.borrower_name;
      state.basic_information.guardian_name = obj.guardian_name;
      state.basic_information.mother_name = obj.mother_name;
      state.basic_information.gender = obj.gender;
      state.basic_information.dob = obj.dob;
      state.basic_information.marital_status = obj.marital_status;
      state.basic_information.mobile_no = obj.mobile_no;
      state.basic_information.email_id = obj.email_id;
      state.basic_information.highest_degree = obj.highest_degree;
      state.basic_information.institute = obj.institute;
    },
    // Auto-fill the Create-Lead form from data already captured for the
    // borrower (KYC docs, penny-drop, Account Aggregator, Credit Report).
    // Only fills a field that is currently empty so it never overwrites what
    // the user already typed. `data` is the backend `get_prefill_data` result.
    PREFILL_FORM_FROM_REPORTS(state, data) {
      if (!data) return;
      const sources = data.sources || {};
      const isEmpty = (v) => v === "" || v === null || v === undefined;

      const merge = (target, source) => {
        if (!target || !source) return;
        Object.keys(source).forEach((key) => {
          const value = source[key];
          if (isEmpty(value)) return;
          if (key in target && isEmpty(target[key])) {
            target[key] = value;
            if (sources[key]) {
              // Reassign the whole map so Vue 2 tracks the new key reactively.
              state.prefill_sources = {
                ...state.prefill_sources,
                [key]: sources[key],
              };
            }
          }
        });
      };

      merge(state.basic_information.basic_details, data.basic_details);
      merge(state.basic_information.current_add, data.current_add);
      merge(state.bank_information, data.bank_information);
      merge(state.employment_information, data.employment_information);
      merge(state.identity_info, data.identity_info);
    },
    SET_BASIC_MOBILE_NO(state, mobile) {
      const value = mobile || "";
      state.basic_information.mobile_no = value;
      if (state.basic_information.basic_details) {
        state.basic_information.basic_details.mobile_no = value;
      }
    },
    SET_EMPLOYMENT_INFO(state, obj) {
      state.employment_information.company_name = obj.company_name;
      state.employment_information.designation = obj.designation;
      state.employment_information.company_address = obj.company_address;
      state.employment_information.monthly_income = obj.monthly_income;
      state.employment_information.work_exp_year = obj.work_exp_year;
      state.employment_information.work_exp_month = obj.work_exp_month;
      state.employment_information.email_id = obj.email_id;
      state.employment_information.employment_type = obj.employment_type;
      state.employment_information.salary_type = obj.salary_type;
      state.employment_information.current_company_exprience = obj.current_company_exprience;
      state.employment_information.business_type = obj.business_type;
      state.employment_information.business_ownership = obj.business_ownership;
      state.employment_information.turnover = obj.turnover;
      state.employment_information.business_vintage = obj.business_vintage;
    },
    SET_PROPERTY_INFO(state, obj){
      state.property_information.total_properties = obj.total_properties;
      state.property_information.property_address = obj.property_address;
      state.property_information.property_type = obj.property_type;
      state.property_information.property_owners = obj.property_owners;
      state.property_information.property_classification = obj.property_classification;
      state.property_information.property_usage = obj.property_usage;
      state.property_information.property_registration_date = obj.property_registration_date;
      state.property_information.market_value = obj.market_value;
      state.property_information.khasara_no = obj.khasara_no;
      state.property_information.ploat_area = obj.ploat_area;
      state.property_information.buildup_area = obj.buildup_area;
      state.property_information.super_buildup_area = obj.super_buildup_area;
      state.property_information.carpet_area = obj.carpet_area;
      state.property_information.diversion_date = obj.diversion_date;
      state.property_information.diversion = obj.diversion;
    },
    SET_BANK_INFO(state, obj) {
      state.bank_information.bank_name = obj.bank_name;
      state.bank_information.account_number = obj.account_number;
      state.bank_information.IFSC_code = obj.IFSC_code;
      state.bank_information.ac_holder_name = obj.ac_holder_name;
      state.bank_information.account_type = obj.account_type;
      state.bank_information.branch_name = obj.branch_name;
      state.bank_information.is_bank_account_primary =
        obj.is_bank_account_primary;
    },
    SET_DOCUMENTS_INFO(state, obj) {
      state.identity_info.aadhar_card_front_file = obj.aadhar_card_front_file;
      state.identity_info.aadhar_card_back_file = obj.aadhar_card_back_file;
      state.identity_info.pan_card_file = obj.pan_card_file || obj.pan_card_url;
      state.identity_info.aadhar_number = obj.aadhar_number;
      state.identity_info.pan_number = obj.pan_number;
      state.identity_info.address_proof_file = obj.address_proof_file;
      state.identity_info.upload_photo_file = obj.upload_photo_file || obj.upload_photo_url;
      state.identity_info.cibil_report_file = obj.cibil_report_file;
    },
    SET_BS_DOCUMENTS_INFO(state, obj) {
      state.uploaded_document.uploaded_url = obj.uploaded_url;
      state.uploaded_document.uploaded_file = obj.uploaded_file;
      state.uploaded_document.document_type = obj.document_type;
      state.uploaded_document.document_password = obj.document_password;
    },
    SET_EXISTING_LEAD_CREATION_ID(state, value) {
      state.existing_lead_creation_id = value;
    },
    // SET_BUSINESS_NEW_LEAD_CREATION(state, value) {
    //   state.business_loan_new_lead_creation = value;
    // },
    SET_IS_EXISTING_CUSTOMER(state, value) {
      state.is_existing_customer = value;
    },
    SET_IS_APPLICANT_KYC_COMPLETED(state, value) {
      state.is_applicant_kyc_completed = value;
    },
    SET_BUSINESS_LOAN_OVERLAY(state, value) {
      state.business_loan_overlay = value;
    },
    SET_DEALER_LEAD_ID(state, value) {
      state.dealer_lead_id = value;
    },
    SET_DEALER_COMPANY(state, value) {
      state.dealer_company = value;
    },
    SET_LOS_AGENT_CHECK_FORM(state, value) {
      state.los_agent_check_form = value;
    },
    SET_BUSINESS_BASIC_DETAILS(state, value) {
      state.business_basic_details = value;
    },
    SET_ARE_BUSINESS_DOCUMENTS_UPLOADED(state, value){
      state.are_business_documents_uploaded = value
    },
    SET_PRODUCT_TYPE(state, value){
      state.product_type = value
    },
    UPDATE_PL_FORMS_STATUS(state, payload) {
      Object.keys(payload).forEach(key => {
        if (Object.prototype.hasOwnProperty.call(state, key)) {
          state[key] = payload[key]
        }
      })},
  },

  actions: {
    setStepperId({ commit }, value) {
      commit("SET_STEPPER_ID", value);
    },
    setBusinessStepperId({ commit }, value) {
      commit("SET_BUSINESS_STEPPER_ID", value);
    },
    // setPropertyStepperId({ commit }, value) {
    //   commit("SET_PROPERTY_STEPPER_ID", value);
    // },
    setVehicleStepperId({ commit }, value) {
      commit("SET_VEHICLE_STEPPER_ID", value);
    },
    setBusinessEntityType({ commit }, value) {
      commit("SET_BUSINESS_ENTITY_TYPE", value);
    },
    setBusinessLeadCreation({ commit }, value) {
      commit("SET_BUSINESS_LEAD_CREATION", value);
    },
     setLAPLeadCreation({ commit }, value) {
      commit("SET_LAP_LEAD_CREATION", value);
    },
    setLeadCreation({ commit }, value) {
      commit("SET_LEAD_CREATION", value);
    },
    setBasicInfo({ commit }, obj) {
      commit("SET_BASIC_INFO", obj);
    },
    prefillFormFromReports({ commit }, data) {
      commit("PREFILL_FORM_FROM_REPORTS", data);
    },
    setBasicMobileNo({ commit }, mobile) {
      commit("SET_BASIC_MOBILE_NO", mobile);
    },
    setLeadDetails({ commit }, obj) {
      commit("SET_LEAD_DETAILS", obj);
    },
    setEmployementDetails({ commit }, obj) {
      commit("SET_EMPLOYMENT_INFO", obj);
    },
    setPropertyDetails({commit},obj){
      commit("SET_PROPERTY_INFO", obj);
    },
    setBankDetails({ commit }, obj) {
      commit("SET_BANK_INFO", obj);
    },
    setIdentityInfo({ commit }, obj) {
      commit("SET_DOCUMENTS_INFO", obj);
    },
    setBsIdentityInfo({ commit }, obj) {
      commit("SET_BS_DOCUMENTS_INFO", obj);
    },
    setExistingLeadCreationId({ commit }, id) {
      commit("SET_EXISTING_LEAD_CREATION_ID", id);
    },
    // setBusinessSSNewLeadCreation({ commit }, id) {
    //   commit("SET_BUSINESS_NEW_LEAD_CREATION", id);
    // },
    setIsExistingCustomer({ commit }, value) {
      commit("SET_IS_EXISTING_CUSTOMER", value);
    },
    setIsApplicantKycCompleted({ commit }, value) {
      commit("SET_IS_APPLICANT_KYC_COMPLETED", value);
    },
    setBusinessLoanOverlay({ commit }, value) {
      commit("SET_BUSINESS_LOAN_OVERLAY", value);
    },
    setHasBlPrimaryBankAccount({ commit }, value) {
      commit("SET_HAS_BL_PRIMARY_BANK_ACCOUNT", value);
    },
    setHasPlPrimaryBankAccount({ commit }, value) {
      commit("SET_HAS_PL_PRIMARY_BANK_ACCOUNT", value);
    },
    setHasBlDocumentsUploaded({ commit }, value) {
      commit("SET_HAS_BL_DOCUMENTS_UPLOADED", value);
    },
    setIsBlPersonalDetailsValid({ commit }, value) {
      commit("SET_IS_BL_PERSONAL_DETAILS_VALID", value);
    },
    setIsBlBusinessDetailsVaild({ commit }, value) {
      commit("SET_IS_BL_BUSINESS_DETAILS_VALID", value);
    },
    setDealerLeadId({ commit }, value) {
      commit("SET_DEALER_LEAD_ID", value);
    },
    setDealerCompany({ commit }, value) {
      commit("SET_DEALER_COMPANY", value);
    },
    setLosAgentCheckForm({ commit }, value) {
      commit("SET_LOS_AGENT_CHECK_FORM", value);
    },
    setBusinessBasicDetails({ commit }, value) {
      commit("SET_BUSINESS_BASIC_DETAILS", value);
    },
    setAreBusinessDocumentsUploaded({ commit }, value){
      commit("SET_ARE_BUSINESS_DOCUMENTS_UPLOADED", value);
    },
    setProductType({ commit }, value){
      commit("SET_PRODUCT_TYPE", value);
    },
    updatePlFormsStatus({ commit }, payload) {
      return new Promise((resolve, reject) => {
        try {
          commit('UPDATE_PL_FORMS_STATUS', payload)
          resolve('User data updated successfully')
        } catch (error) {
          reject(error)
        }
      })
    },
  },
};
